import React, { useState } from 'react';
import { FaCheckCircle } from 'react-icons/fa';

function InvitePlayerModal({ onClose, onSubmit, playerAdded, smsSent = false, isAcademy = false }) {
    const [step, setStep] = useState(1);
    const [inviteForm, setInviteForm] = useState({
        first_name: '',
        last_name: '',
        phone: '',
        email: ''
    });
    const [error, setError] = useState('');
    const [isSubmitting, setIsSubmitting] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');

        if (!inviteForm.first_name || !inviteForm.last_name) {
            setError('Please fill in all required fields');
            return;
        }

        if (!isAcademy && !inviteForm.phone) {
            setError('Please fill in all required fields');
            return;
        }

        setIsSubmitting(true);
        try {
            await onSubmit(inviteForm);
            setStep(2);
        } catch (submitError) {
            setError(submitError.message || 'Failed to add player');
        } finally {
            setIsSubmitting(false);
        }
    };

    const addedName = playerAdded?.name || `${inviteForm.first_name} ${inviteForm.last_name}`.trim();

    return (
        <div className="modal-overlay">
            <div className="modal">
                <button 
                    className="modal-close"
                    onClick={onClose}
                >
                    ×
                </button>
                <h2>Add Player</h2>
                
                {step === 1 ? (
                    <>
                        <p className="modal-description">
                            {isAcademy
                                ? 'Enter the player\'s name. You can invite a parent or guardian afterwards.'
                                : 'Enter player details to add them to your team.'}
                        </p>
                        {error && <div className="error-message">{error}</div>}
                        <form onSubmit={handleSubmit}>
                            <div className="form-group">
                                <label>First Name *</label>
                                <input
                                    type="text"
                                    value={inviteForm.first_name}
                                    onChange={(e) => setInviteForm({
                                        ...inviteForm,
                                        first_name: e.target.value
                                    })}
                                    required
                                />
                            </div>
                            <div className="form-group">
                                <label>Last Name *</label>
                                <input
                                    type="text"
                                    value={inviteForm.last_name}
                                    onChange={(e) => setInviteForm({
                                        ...inviteForm,
                                        last_name: e.target.value
                                    })}
                                    required
                                />
                            </div>
                            {!isAcademy && (
                                <>
                                    <div className="form-group">
                                        <label>Phone *</label>
                                        <input
                                            type="tel"
                                            value={inviteForm.phone}
                                            onChange={(e) => setInviteForm({
                                                ...inviteForm,
                                                phone: e.target.value.replace(/\D/g, '').slice(0, 15)
                                            })}
                                            required
                                        />
                                    </div>
                                    <div className="form-group">
                                        <label>Email (optional)</label>
                                        <input
                                            type="email"
                                            value={inviteForm.email}
                                            onChange={(e) => setInviteForm({
                                                ...inviteForm,
                                                email: e.target.value
                                            })}
                                        />
                                    </div>
                                </>
                            )}
                            <div className="modal-buttons">
                                <button type="submit" disabled={isSubmitting}>
                                    {isSubmitting ? 'Adding...' : 'Continue'}
                                </button>
                            </div>
                        </form>
                    </>
                ) : (
                    <>
                        <div className="success-message player-added-success">
                            <div className="success-icon">
                                <FaCheckCircle size={32} />
                            </div>
                            <div className="success-content">
                                <h3>Player Added Successfully!</h3>
                                <p>
                                    <strong>{addedName}</strong> has been added to your team
                                    {smsSent ? ' and an invitation SMS has been sent' : ''}.
                                    {isAcademy
                                        ? ' Next, invite a parent or guardian to link their account.'
                                        : ' You can now assign them to your matches.'}
                                </p>
                            </div>
                        </div>
                        
                        <div className="modal-buttons">
                            <button onClick={onClose}>Done</button>
                        </div>
                    </>
                )}
            </div>
        </div>
    );
}

export default InvitePlayerModal;
